var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagraminline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8 0h8.4C17.403 0 20 2.77 20 6.185v8.959c0 3.415-2.597 6.185-5.8 6.185H5.8c-3.203 0-5.8-2.77-5.8-6.185V6.185C0 2.77 2.597 0 5.8 0zm-.2 2.133c-1.988 0-3.6 1.719-3.6 3.84v9.384c0 2.12 1.612 3.84 3.6 3.84h8.8c1.988 0 3.6-1.72 3.6-3.84V5.972c0-2.12-1.612-3.84-3.6-3.84H5.6zm9.65 1.6c.69 0 1.25.597 1.25 1.333s-.56 1.333-1.25 1.333S14 5.802 14 5.066s.56-1.333 1.25-1.333zM10 5.333c2.761 0 5 2.387 5 5.332 0 2.944-2.239 5.332-5 5.332s-5-2.388-5-5.332c0-2.945 2.239-5.333 5-5.333zm0 2.132c-1.657 0-3 1.432-3 3.2 0 1.767 1.343 3.199 3 3.199s3-1.432 3-3.2c0-1.767-1.343-3.199-3-3.199z",
    fill: "#fff"
  })));
}

export default SvgInstagraminline;